export const JobDatesOptions = [
  { label: 'Hoy', value: 0 },
  { label: 'Últimos 7 días', value: 7 },
  { label: 'Últimos 15 días', value: 15 },
  { label: 'Último mes', value: 30 },
  { label: 'Últimos 2 meses', value: 60 },
];
